module.exports = __webpack_public_path__ + "static/media/image12.063c5f0b.JPG";